import { AuthenLayoutStyled } from "./styled";
import { Outlet } from "react-router-dom";
import { LanguageWidget } from "widgets";
import useIsMobile from "utils/hooks/useIsMobile";

const AuthenLayout = () => {
  const isMobile = useIsMobile();

  return (
    <AuthenLayoutStyled>
      {isMobile ? (
        <section className="authen_mobile_layout">
          <div className="lagnuage_mobile_wrap">
            <LanguageWidget />
          </div>
          <div className="body_mobile_container_authen_layout">
            <img
              className="logo_mobile_authen_layout"
              alt="Yamaha Logo"
              src={"/assets/images/logos/logo.svg"}
            />
            <Outlet />
          </div>
        </section>
      ) : (
        <section className="desktop_authen_layout">
          <div className="body_container_authen_layout">
            <div className="content_authen_layout">
              <div className="lagnuage_wrap">
                <LanguageWidget />
              </div>
              <img
                className="logo_authen_layout"
                alt="Yamaha Logo"
                src={"/assets/images/logos/logo.svg"}
              />
              <Outlet />
            </div>
          </div>
        </section>
      )}
    </AuthenLayoutStyled>
  );
};

export default AuthenLayout;
